import PostalCode from "@/model/postalCode";
import api from "./api";
import { AxiosResponse } from "axios";

class PostalCodeApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getDetail(code): Promise<AxiosResponse> {
    return this.getHttp().get<PostalCode>("/postal-codes/" + code);
  }
}
export default new PostalCodeApi();
